import { CreateSimilarityReportCommand, ReportUrlDto, SimilarityReportMode, SimilarityFormConfigurationsDto, SimilarityReportStatusDto, SimilarityReportStatuses, VariableCategoryDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface SimilarityReportState {
  isCustomReportDialogOpended: boolean;
  isSimilarityProgressDialogOpened: boolean;
  createReportLoading: LoadingState;
  getReportLoading: LoadingState;
  getReportStatusLoading: LoadingState;
  errorMessage?: string;
  token?: string | null | undefined;
  status?: SimilarityReportStatuses;
  stages?: SimilarityReportStatusDto;
  statusMessage?: string;
  urls?: ReportUrlDto[];
  similarityFormRequest?:CreateSimilarityReportCommand;
  selectedVariableCategories?:VariableCategoryDto[];

  savedSimilarityConfigNames: string[];
  savedSimilarityConfigNamesLoading: LoadingState;
  similarityFormConfig?:SimilarityFormConfigurationsDto;
  similarityFormConfigLoading:LoadingState;
  saveSimilarityFormDataLoading:LoadingState;
  savedSimilarityConfigName?: string;
  similarityReportMode?: SimilarityReportMode
}

export const initialSimilarityReportState: SimilarityReportState = {
  isCustomReportDialogOpended: false,
  isSimilarityProgressDialogOpened: false,
  createReportLoading: LoadingState.idle,
  getReportLoading: LoadingState.idle,
  getReportStatusLoading: LoadingState.idle,

  savedSimilarityConfigNames: [],
  savedSimilarityConfigNamesLoading: LoadingState.idle,
  similarityFormConfigLoading:LoadingState.idle,
  saveSimilarityFormDataLoading: LoadingState.idle,
};
